/**
 * CSV Export Button Component
 *
 * Button for exporting accounts to CSV file.
 */

import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '@/shared/ui/components/Button';
import type { CsvExportState } from '../model/types';

interface CsvExportButtonProps {
  state: CsvExportState;
  className?: string;
}

export const CsvExportButton: React.FC<CsvExportButtonProps> = ({ state, className }) => {
  const { isExporting, handleExport } = state;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleExport}
      disabled={isExporting}
      className={className}
    >
      <Download className="w-4 h-4 mr-1" />
      {isExporting ? 'CSV 내보내는 중...' : 'CSV 내보내기'}
    </Button>
  );
};

CsvExportButton.displayName = 'CsvExportButton';
